// @react-functional

import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useModal } from '../../../components/modal/useModal';
import { AddDecisionWatcherModal } from './AddDecisionWatcherModal';
import { WatcherSearchQuery } from '../../../watchers/watchers.types';
import { StateType } from '../../../state/reducers';
import {
  getWatcherTagsFromState,
  getSearchQueryParamsFromState,
} from '../../state/utils';
import { snakeToCamel } from '../../../caseUtils';
import { getNewWatcherQueryParams } from './searchWatcherUtils';

type Props = {
  createWatcher: (searchQueryTypes: Array<WatcherSearchQuery>) => void;
};

export const useDecisionWatcherModal = ({ createWatcher }: Props) => {
  const { queryParameters, tags } = useSelector(
    ({ queryParams, results }: StateType) => {
      return {
        tags: getWatcherTagsFromState(queryParams, results),
        queryParameters: {
          ...getNewWatcherQueryParams(
            snakeToCamel(getSearchQueryParamsFromState(queryParams)),
          ),
        },
      };
    },
    shallowEqual,
  );

  const { openModal } = useModal(
    modalProps => (
      <AddDecisionWatcherModal
        queryParameters={queryParameters}
        tags={tags}
        createWatcher={createWatcher}
        {...modalProps}
      />
    ),
    [tags, queryParameters, createWatcher],
  );
  return openModal;
};
